module.exports = __webpack_public_path__ + "static/media/telegram.ce31584b.svg";